module.exports = __webpack_public_path__ + "media/recipes/5-e895cde0.png";